export default "static/media/kkcabinets.3b4ae5d.svg"